@let isAddDisabled = control.invalid || !control.value;

@if (!hideTitle()) {
  <h4 class="title">{{ 'header.notes' | translate }}</h4>
}

<rp-textarea
  [formControl]="control"
  [label]="'pages.partners.labels.notes' | translate"
  [placeholder]="'pages.partners.placeholders.notes' | translate"
  [subscriptSizing]="subscriptSizing()"
/>

<rp-button type="primary" size="s" fullWidth class="action" [disabled]="isAddDisabled" (click)="onAddComment()">
  {{ 'general.buttons.add' | translate }}
</rp-button>

@if (itemsLength()) {
  <div class="history" *rpSpinner="isLoading()" [class.history__space-bottom]="itemsLength() <= 10">
    @for (note of notes(); track $index) {
      <div class="history__container">
        <div class="history__header">
          <span class="history__creator">{{ note.author.fullName }}</span>
          <span class="history__action"> {{ 'general.addedAComment' | translate }} - {{ note.createdAt | date: DateFormat.Full }} </span>
        </div>

        <div class="history__comment">{{ note.text }}</div>
      </div>
    }
  </div>
}

@if (itemsLength() > 10) {
  <mat-paginator
    [pageSize]="pageSize()"
    [pageIndex]="pageIndex()"
    [length]="itemsLength()"
    [pageSizeOptions]="pageSizeOptions()"
    [hidePageSize]="hidePageSize()"
    (page)="onPageChange($event)"
  />
}
